/**
 * Each card pairs one of the product photographs with the part of the library
 * it demonstrates, so the deck reads as documentation rather than decoration.
 * `accent` is sampled from the photograph itself.
 */
export interface CardData {
  id: string;
  image: string;
  accent: string;
  kicker: string;
  title: string;
  body: string;
  spec: [string, string][];
}

export const CARDS: CardData[] = [
  {
    id: 'sticky',
    image: '/images/1.jpg',
    accent: '#2ab8be',
    kicker: 'How it works',
    title: 'Sticky, not scripted',
    body: 'Every card pins itself with position: sticky at an offset derived from its place in the deck. That is the whole mechanism. Leave the effect props alone and the library attaches no scroll listener at all.',
    spec: [
      ['position', 'sticky'],
      ['offset', 'live'],
      ['listeners', '0'],
    ],
  },
  {
    id: 'counting',
    image: '/images/2.jpg',
    accent: '#8fae7f',
    kicker: 'Ergonomics',
    title: 'It counts for you',
    body: 'No card on this page passes an index. The container numbers its own children, including through fragments, so a deck built from an array needs nothing threaded through it.',
    spec: [
      ['index', 'auto'],
      ['fragments', 'flattened'],
      ['v1 index', 'still honoured'],
    ],
  },
  {
    id: 'effects',
    image: '/images/3.jpg',
    accent: '#f5c518',
    kicker: 'Motion',
    title: 'Shrink, fade, tilt',
    body: 'Three numbers describe what happens to a card by the time the next one covers it. Every animated card shares one scroll listener and one animation frame, so a deck of twenty costs what a deck of two does.',
    spec: [
      ['scaleStep', 'live'],
      ['fadeStep', 'live'],
      ['rotateStep', 'live'],
    ],
  },
  {
    id: 'progress',
    image: '/images/4.jpg',
    accent: '#e0a0ab',
    kicker: 'Escape hatch',
    title: 'Read the coverage',
    body: 'The percentage in the corner of each card comes from useStackProgress. It runs inside the shared frame and never re-renders the component, so you can drive anything the built-in props do not cover.',
    spec: [
      ['hook', 'useStackProgress'],
      ['re-renders', '0'],
      ['range', '0 → 1'],
    ],
  },
];
